
/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import { Paper } from "@mui/material";
import CustomDataGrid from "../../Shared/Table/CustomDataGrid";
import { prepareTemplateCellDataGrid } from "../../../pages/Configuration/helpers";
import { useTaskTemplateDisplay } from "../../../pages/Tasks/hooks";
import { configTemplateColumns } from "../../Shared/Table/Columns";
import { ITemplates } from "../../../store/api/tasks/types";
import { GridEventListener, GridRowParams, GridSortModel } from "@mui/x-data-grid-pro";
import { setScheduledTask } from "../../../store/api/tasks/reducer";
import { useStoreDispatch } from "../../../store/hooks";
import { getSortBy } from "../../../utils/helpers";
import { useSelector } from "react-redux";
import { tasksSelector } from "../../../store/api/tasks/selector";
import { useEffect, useMemo, useState } from "react";
import { IKeyValueAny } from "../../Administrations/types";

export const BulkConfiguration = () => {
    const dispatch = useStoreDispatch();
    const { data = [], isLoading, setSortOrderToTaskTemplate } = useTaskTemplateDisplay();
    const rowsData = useMemo(() => prepareTemplateCellDataGrid(data) || [], [data]);
    const scheduledtasks = useSelector(tasksSelector);

    const [templateIds, setTemplateIds] = useState<Array<number>>([]);

    useEffect(() => {
        if (!!rowsData && rowsData.length > 0) {
            const selectedId = rowsData.filter((item: IKeyValueAny) => item.templateName === scheduledtasks.templateName)[0]?.id;
            !!selectedId && setTemplateIds([selectedId]);
        }
    }, [rowsData, scheduledtasks.templateName])

    const handleRowClicked: GridEventListener<"rowClick"> = (params: GridRowParams<ITemplates>) => {
        setTemplateIds([params.row?.id ? params.row?.id : 0])
        dispatch(setScheduledTask({ templateName: params.row?.templateName }));
    };
    return (
        <Paper variant="outlined" sx={{ backgroundColor: "inherit" }}>
            <CustomDataGrid
                tableId="bulkConfiguratin"
                rows={rowsData}
                columns={configTemplateColumns}
                rowCount={rowsData?.length}
                loading={isLoading}
                disableColumnMenu={true}
                rowSelectionModel={templateIds}
                disableMultipleRowSelection={true}
                getRowId={(row: ITemplates) => Number(row.id)}
                onRowClick={handleRowClicked}
                sx={{ height: "500px" }}
                hideFooter={true}
                onSortModelChange={(params: GridSortModel) => setSortOrderToTaskTemplate(getSortBy(params))}
            />
        </Paper>

    );
};